import {
  validateImageFile,
  ValidateImageFileOptions,
} from 'components/flowBuilder/utils/files';
import {
  saveImageFile,
  saveImageFromUrl,
} from 'components/flowBuilder/utils/messages';
import { useState } from 'react';

interface UseImageFileUploadOptions extends ValidateImageFileOptions {
  imageUploadUrl?: string;
}

type ImageFileUpload = [
  isUploadingImageFile: boolean,
  uploadImageFile: (file: File) => Promise<string>,
  uploadImageFromUrl: (url: string) => Promise<string>,
];

const useImageFileUpload = (
  options?: UseImageFileUploadOptions,
): ImageFileUpload => {
  const [isUploadingImageFile, setUploadingImageFile] = useState(false);

  const uploadImageFile = async (file: File) => {
    try {
      validateImageFile(file, options);
      setUploadingImageFile(true);
      const mediaUrl = await saveImageFile(file, options?.imageUploadUrl);
      setUploadingImageFile(false);
      return mediaUrl;
    } catch (err) {
      setUploadingImageFile(false);
      throw err;
    }
  };

  const uploadImageFromUrl = async (url: string) => {
    try {
      setUploadingImageFile(true);
      const mediaUrl = await saveImageFromUrl(url, options?.rcsMessageCategory);
      setUploadingImageFile(false);
      return mediaUrl;
    } catch (err) {
      setUploadingImageFile(false);
      throw err;
    }
  };

  return [isUploadingImageFile, uploadImageFile, uploadImageFromUrl];
};

export default useImageFileUpload;
